<template>
  <b-modal
    id="modal-fb-like-box"
    scrollable
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-header style="align-items: center;">
      <div class="w-100 px-5">
        <div class="d-flex justify-content-between align-items-center">
          <TitleModal :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX', languageEngine)" />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="close mr-0 pr-10" type="button" style="font-size: 16px">
          <i class="fal fa-question-circle"></i>
        </div>
        <div
          id="close-modal-select-album"
          type="button"
          class="close-modal"
          @click="cancelHandle"
          aria-label="Close"
        >
          <i class="fal fa-times fs-16"></i>
        </div>
      </div>
    </template>


    <template>
      <FormGroupHorizontal 
        :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX_URL', languageEngine)"
        :split="'4:8'"
        :contentClass="'align-self-center'"
      >
        <b-form-input
          placeholder="Enter your name"
          v-model="data.url"
        />
      </FormGroupHorizontal>

      <!-- <b-row class="mt-3">
        <b-col cols="4" align-self="center"> Facebook Likebox size </b-col>
        <b-col cols="4" align-self="center">
          <small>Width(px)</small>
          <b-form-input
            :number="true"
            placeholder="Enter width"
            v-model="config.width"
          ></b-form-input>
          <small class="text-muted">min. 180 px to max. 500 px</small>
        </b-col>
        <b-col cols="4" align-self="center">
          <small>Height(px)</small>
          <b-form-input
            :number="true"
            placeholder="Enter height"
            v-model="config.height"
          ></b-form-input>
          <small class="text-muted">min. 150 px to max. 500 px</small>
        </b-col>
      </b-row> -->
      <hr />
      <FormGroupHorizontal 
        :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX', languageEngine)"
        :split="'4:8'"
        :contentClass="'align-self-center'"
      >
        <b-form-checkbox
          id="checkbox-small-header"
          v-model="config.isSmallHeader"
          name="checkbox-small-header"
          :value="true"
          :unchecked-value="false"
        />
      </FormGroupHorizontal>
      <FormGroupHorizontal 
        :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX_FRIENDFACE', languageEngine)"
        :split="'4:8'"
        :contentClass="'align-self-center'"
      >
        <b-form-checkbox
          id="checkbox-friend-faces"
          v-model="config.isShowFace"
          name="checkbox-friend-faces"
          :value="true"
          :unchecked-value="false"
        />
      </FormGroupHorizontal>
       <FormGroupHorizontal 
        :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX_HIDECOVER', languageEngine)"
        :split="'4:8'"
        :contentClass="'align-self-center'"
      >
        <b-form-checkbox
          id="checkbox-hide-cover"
          v-model="config.isHideCoverPage"
          name="checkbox-hide-cover"
          :value="true"
          :unchecked-value="false"
        />
      </FormGroupHorizontal>
      <FormGroupHorizontal 
        :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX_TIMELINETABS', languageEngine)"
        :split="'4:8'"
        :contentClass="'align-self-center'"
      >
        <b-form-checkbox
          id="checkbox-timeline-tabs"
          v-model="config.isShowTimeLineTab"
          name="checkbox-timeline-tabs"
          :value="true"
          :unchecked-value="false"
        />
      </FormGroupHorizontal>
      <FormGroupHorizontal 
        :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX_EVENTTABS', languageEngine)"
        :split="'4:8'"
        :contentClass="'align-self-center'"
      >
        <b-form-checkbox
          id="checkbox-event-tabs"
          v-model="config.isShowEventsTab"
          name="checkbox-event-tabs"
          :value="true"
          :unchecked-value="false"
        />
      </FormGroupHorizontal>
      <FormGroupHorizontal 
        :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX_MESSAGETABS', languageEngine) "
        :split="'4:8'"
        :contentClass="'align-self-center'"
      >
        <b-form-checkbox
          id="checkbox-msg-tab"
          v-model="config.isShowMessageTab"
          name="checkbox-msg-tab"
          :value="true"
          :unchecked-value="false"
        />
      </FormGroupHorizontal>
      <FormGroupHorizontal 
        :label="$t('engine.sidebarNavigation.component.FOOTER_MODAL_FBLIKEBOX_HIDECUSTOM', languageEngine) "
        :split="'4:8'"
        :contentClass="'align-self-center'"
      >
        <b-form-checkbox
          id="hide-call"
          v-model="config.isHideCustomCall"
          name="hide-call"
          :value="true"
          :unchecked-value="false"
        />
      </FormGroupHorizontal>
    </template>
    <template #modal-footer>
      <b-button variant="blue" class="mr-2" @click="save()">
        <i class="far fa-check"></i> {{$t('engine.common.btnSave', languageEngine)}}
      </b-button>
      <b-button variant="default" @click="cancelHandle()">
        <i class="far fa-times"></i> {{$t('engine.common.btnCancel', languageEngine)}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';


export default {
  components:{
    TitleModal,
    FormGroupHorizontal
  },
  computed: {
    ...mapGetters({
      modal: "design/modal",
      siteComponents: "design/metadata/siteComponents",
      languageEngine: "design/userPreference/languageEngine",
      
    }),
    fbLikeBox() {
      return JSON.parse(
        JSON.stringify(
          this.siteComponents.FOOTER_WIDGET_FBLIKEBOX || { style: {}, data: {} }
        )
      );
    },
    config() {
      return this.fbLikeBox.style;
    },
    data() {
      return this.fbLikeBox.data;
    },
  },
  watch: {
    modal: {
      handler() {
        if (this.modal == "modal-fb-like-box") {
          this.$bvModal.show("modal-fb-like-box");
        }
      },
    },
  },
  methods: {
    save() {
      this.siteComponents.FOOTER_WIDGET_FBLIKEBOX = { ...this.fbLikeBox };
      this.$store.dispatch("design/setModal", { name: "" });
      this.$store.dispatch("design/snapshot/genSnapshot");
      this.$bvModal.hide("modal-fb-like-box");
    },
    cancelHandle() {
      this.$store.dispatch("design/setModal", { name: "" });
      this.$bvModal.hide("modal-fb-like-box");
    },
  },
};
</script>

<style scoped>
.check-box-title {
  font-size: 14px;
}
</style>
